import { createSlice } from '@reduxjs/toolkit';

const LaborantSlice = createSlice({
    name: 'labFormOutput',
    initialState:{
        formCompleted: false,
        laborantCard: {
            description: '',
            cassettes: '',
            archive: '',
            calcium: '',
            doc: '',
            laborant: ''
        }
    },
    reducers: {
        gistologyCreation: (state,action) => {
            state.formCompleted = true
            state.laborantCard = action.payload.credential
        },
        cardClean: (state) => {
            state.formCompleted = false
            state.laborantCard = {
                description: '',
                cassettes: '',
                archive: '',
                calcium: '',
                doc: '',
                laborant: ''
            }
        },
        expressCreation: (state,action)=>{
            state.formCompleted = true
            state.laborantCard = action.payload.credential
        }
    }
})

export const {gistologyCreation, cardClean, expressCreation} = LaborantSlice.actions;
export default LaborantSlice;